import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink, useNavigate } from "react-router-dom";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import {
    FiDownload,
    FiTrendingUp,
    FiTrendingDown,
    FiRefreshCw,
    FiDollarSign,
} from "react-icons/fi";

// Format number in Indian Rupees
const formatINR = (amount) => {
    const numAmount = typeof amount === "number" ? amount : parseFloat(amount) || 0;
    return `₹${Number(numAmount.toFixed(0)).toLocaleString("en-IN")}`;
};

// Format percentage
const formatPercent = (value) => `${value >= 0 ? "+" : ""}${value.toFixed(2)}%`;

// Format date
const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
};

export default function HoldingDetails() {
    const navigate = useNavigate();
    const [selectedFolio, setSelectedFolio] = useState("FOLIO001");

    // Static Data - Fund/Scheme Information
    const fundInfo = {
        fundName: "Axis Bluechip Fund - Direct Growth",
        schemeCode: "AXISBLUECHIP-DIR-G",
        amc: "Axis Mutual Fund",
        category: "Large Cap",
        risk: "Moderate",
        currentNAV: 52.3,
        lastUpdated: "2024-01-15",
    };

    // Static Data - Folio Information
    const folios = [
        {
            folioNo: "FOLIO001",
            pan: "ABCDE1234F",
            kycStatus: "KYC Verified",
            registrationDate: "2020-05-15",
            totalUnits: 120.45,
            avgNAV: 48.5,
            currentValue: 62995.35,
            investedAmount: 58418.25,
            gain: 4577.1,
            gainPercent: 7.84,
            xirr: 12.5,
        },
        {
            folioNo: "FOLIO002",
            pan: "ABCDE1234F",
            kycStatus: "KYC Verified",
            registrationDate: "2021-03-20",
            totalUnits: 85.2,
            avgNAV: 50.2,
            currentValue: 44559.6,
            investedAmount: 42770.4,
            gain: 1789.2,
            gainPercent: 4.18,
            xirr: 8.2,
        },
    ];

    // Static Data - Transactions
    const transactions = [
        {
            id: 1,
            date: "2023-01-15",
            type: "Purchase",
            amount: 10000,
            nav: 45.2,
            units: 221.24,
            folioNo: "FOLIO001",
            status: "Completed",
        },
        {
            id: 2,
            date: "2023-02-20",
            type: "Purchase",
            amount: 15000,
            nav: 46.8,
            units: 320.51,
            folioNo: "FOLIO001",
            status: "Completed",
        },
        {
            id: 3,
            date: "2023-03-15",
            type: "SIP",
            amount: 5000,
            nav: 47.5,
            units: 105.26,
            folioNo: "FOLIO001",
            status: "Completed",
        },
        {
            id: 4,
            date: "2023-04-10",
            type: "SIP",
            amount: 5000,
            nav: 48.2,
            units: 103.73,
            folioNo: "FOLIO001",
            status: "Completed",
        },
        {
            id: 5,
            date: "2023-05-15",
            type: "SIP",
            amount: 5000,
            nav: 49.1,
            units: 101.83,
            folioNo: "FOLIO001",
            status: "Completed",
        },
        {
            id: 6,
            date: "2023-06-12",
            type: "Redemption",
            amount: 8000,
            nav: 50.5,
            units: -158.42,
            folioNo: "FOLIO001",
            status: "Completed",
        },
        {
            id: 7,
            date: "2023-07-15",
            type: "SIP",
            amount: 5000,
            nav: 51.2,
            units: 97.66,
            folioNo: "FOLIO001",
            status: "Completed",
        },
        {
            id: 8,
            date: "2023-08-10",
            type: "Switch In",
            amount: 12000,
            nav: 50.8,
            units: 236.22,
            folioNo: "FOLIO001",
            status: "Completed",
        },
        {
            id: 9,
            date: "2023-09-15",
            type: "SIP",
            amount: 5000,
            nav: 51.5,
            units: 97.09,
            folioNo: "FOLIO001",
            status: "Completed",
        },
        {
            id: 10,
            date: "2023-10-15",
            type: "SIP",
            amount: 5000,
            nav: 52.0,
            units: 96.15,
            folioNo: "FOLIO001",
            status: "Completed",
        },
    ];

    // Performance Chart Data
    const performanceData = [
        { month: "Jan", nav: 45.2, value: 10000 },
        { month: "Feb", nav: 46.8, value: 15000 },
        { month: "Mar", nav: 47.5, value: 20000 },
        { month: "Apr", nav: 48.2, value: 25000 },
        { month: "May", nav: 49.1, value: 30000 },
        { month: "Jun", nav: 50.5, value: 35000 },
        { month: "Jul", nav: 51.2, value: 40000 },
        { month: "Aug", nav: 50.8, value: 45000 },
        { month: "Sep", nav: 51.5, value: 50000 },
        { month: "Oct", nav: 52.0, value: 55000 },
        { month: "Nov", nav: 52.3, value: 60000 },
        { month: "Dec", nav: 52.3, value: 62995 },
    ];

    const selectedFolioData = folios.find((f) => f.folioNo === selectedFolio) || folios[0];

    const handleExport = () => {
        alert("Export functionality will be implemented");
    };

    const handleRedeem = () => {
        navigate("/redeemMf");
    };

    const handleSwitch = () => {
        navigate("/switchmf");
    };

    return (
        <>
            <ClientNavbar />
            <div className="page-content" style={{ background: "#f1f5f9" }}>
                    {/* Header */}
                    <div className="card shadow-sm p-4 mb-4">
                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                            <div>
                                <h3 className="text-primary mb-2">Holding Details</h3>
                                <nav
                                    aria-label="breadcrumb"
                                    style={{ "--bs-breadcrumb-divider": "none" }}
                                >
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item">
                                            <NavLink to="/overview">Dashboard</NavLink> /
                                        </li>
                                        <li className="breadcrumb-item">
                                            <NavLink to="/clientmutualfunds">Portfolio</NavLink> /
                                        </li>
                                        <li className="breadcrumb-item active">Holding Details</li>
                                    </ol>
                                </nav>
                            </div>
                            <div className="d-flex gap-2 align-items-center flex-wrap mt-2">
                                <button
                                    className="btn btn-primary"
                                    onClick={handleExport}
                                >
                                    {/* <FiDownload className="me-1" /> */}
                                    Export
                                </button>
                                <button
                                    className="btn btn-primary"
                                    onClick={handleRedeem}
                                >
                                    {/* <FiDollarSign className="me-1" /> */}
                                    Redeem
                                </button>
                                <button
                                    className="btn btn-primary"
                                    onClick={handleSwitch}
                                >
                                    {/* <FiRefreshCw className="me-1" /> */}
                                    Switch
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Fund Information Card */}
                    <div className="card shadow-sm p-4 mb-4">
                        <h5 className="text-primary mb-3">Fund Information</h5>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <small className="text-muted">Fund Name</small>
                                <div className="fw-semibold">{fundInfo.fundName}</div>
                            </div>
                            <div className="col-md-3 mb-3">
                                <small className="text-muted">Scheme Code</small>
                                <div className="fw-semibold">{fundInfo.schemeCode}</div>
                            </div>
                            <div className="col-md-3 mb-3">
                                <small className="text-muted">AMC</small>
                                <div className="fw-semibold">{fundInfo.amc}</div>
                            </div>
                            <div className="col-md-3 mb-3">
                                <small className="text-muted">Category</small>
                                <div>
                                    <span className="badge bg-info">{fundInfo.category}</span>
                                </div>
                            </div>
                            <div className="col-md-3 mb-3">
                                <small className="text-muted">Risk Level</small>
                                <div>
                                    <span className="badge bg-success">{fundInfo.risk}</span>
                                </div>
                            </div>
                            <div className="col-md-3 mb-3">
                                <small className="text-muted">Current NAV</small>
                                <div className="fw-semibold text-primary">
                                    {formatINR(fundInfo.currentNAV)}
                                </div>
                            </div>
                            <div className="col-md-3 mb-3">
                                <small className="text-muted">Last Updated</small>
                                <div className="fw-semibold">
                                    {formatDate(fundInfo.lastUpdated)}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Folio Selection */}
                    <div className="card shadow-sm p-3 mb-4">
                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                            <h6 className="mb-0">Select Folio</h6>
                            <select
                                className="form-select"
                                style={{ maxWidth: "300px" }}
                                value={selectedFolio}
                                onChange={(e) => setSelectedFolio(e.target.value)}
                            >
                                {folios.map((folio) => (
                                    <option key={folio.folioNo} value={folio.folioNo}>
                                        {folio.folioNo} - {folio.kycStatus}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Folio Information */}
                    <div className="card shadow-sm p-4 mb-4">
                        <h5 className="text-primary mb-3">Folio Information</h5>
                        <div className="row">
                            <div className="col-md-3 mb-3">
                                <small className="text-muted">Folio Number</small>
                                <div className="fw-semibold">{selectedFolioData.folioNo}</div>
                            </div>
                            <div className="col-md-3 mb-3">
                                <small className="text-muted">PAN</small>
                                <div className="fw-semibold">{selectedFolioData.pan}</div>
                            </div>
                            <div className="col-md-3 mb-3">
                                <small className="text-muted">KYC Status</small>
                                <div>
                                    <span className="badge bg-success">
                                        {selectedFolioData.kycStatus}
                                    </span>
                                </div>
                            </div>
                            <div className="col-md-3 mb-3">
                                <small className="text-muted">Registration Date</small>
                                <div className="fw-semibold">
                                    {formatDate(selectedFolioData.registrationDate)}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Performance Metrics */}
                    <div className="row mb-4">
                        <div className="col-md-3 col-sm-6 mb-3">
                            <div className="card shadow-sm h-100">
                                <div className="card-body">
                                    <h6 className="text-muted mb-2">Total Units</h6>
                                    <h4 className="text-primary mb-0">
                                        {selectedFolioData.totalUnits.toFixed(2)}
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-6 mb-3">
                            <div className="card shadow-sm h-100">
                                <div className="card-body">
                                    <h6 className="text-muted mb-2">Average NAV</h6>
                                    <h4 className="mb-0">
                                        {formatINR(selectedFolioData.avgNAV)}
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-6 mb-3">
                            <div className="card shadow-sm h-100">
                                <div className="card-body">
                                    <h6 className="text-muted mb-2">Current Value</h6>
                                    <h4 className="text-primary mb-0">
                                        {formatINR(selectedFolioData.currentValue)}
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-6 mb-3">
                            <div className="card shadow-sm h-100">
                                <div className="card-body">
                                    <h6 className="text-muted mb-2">Invested Amount</h6>
                                    <h4 className="mb-0">
                                        {formatINR(selectedFolioData.investedAmount)}
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-6 mb-3">
                            <div className="card shadow-sm h-100">
                                <div className="card-body">
                                    <h6 className="text-muted mb-2">Gain/Loss</h6>
                                    <h4
                                        className={`mb-0 ${selectedFolioData.gain >= 0
                                            ? "text-success"
                                            : "text-danger"
                                            }`}
                                    >
                                        {selectedFolioData.gain >= 0 ? (
                                            <FiTrendingUp className="me-1" />
                                        ) : (
                                            <FiTrendingDown className="me-1" />
                                        )}
                                        {formatINR(selectedFolioData.gain)} (
                                        {formatPercent(selectedFolioData.gainPercent)})
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-6 mb-3">
                            <div className="card shadow-sm h-100">
                                <div className="card-body">
                                    <h6 className="text-muted mb-2">XIRR</h6>
                                    <h4 className="text-success mb-0">
                                        {formatPercent(selectedFolioData.xirr)}
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Performance Chart */}
                    <div className="card shadow-sm p-4 mb-4">
                        <h5 className="text-primary mb-3">NAV Performance</h5>
                        <ResponsiveContainer width="100%" height={300}>
                            <LineChart data={performanceData}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="month" />
                                <YAxis />
                                <Tooltip
                                    formatter={(value, name) => [
                                        name === "nav" ? formatINR(value) : formatINR(value),
                                        name === "nav" ? "NAV" : "Value",
                                    ]}
                                />
                                <Legend />
                                <Line
                                    type="monotone"
                                    dataKey="nav"
                                    stroke="#1bafb4"
                                    strokeWidth={2}
                                    name="NAV"
                                />
                                <Line
                                    type="monotone"
                                    dataKey="value"
                                    stroke="#0f766e"
                                    strokeWidth={2}
                                    name="Portfolio Value"
                                />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>

                    {/* Transactions Table */}
                    <div className="card shadow-sm mb-4">
                        <div className="card-header bg-white d-flex justify-content-between align-items-center">
                            <h5 className="mb-0">Transaction History</h5>
                            <span className="badge bg-primary">
                                {transactions.length} Transactions
                            </span>
                        </div>
                        <div className="card-body p-0">
                            <div className="table-responsive">
                                <table className="table table-hover mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Date</th>
                                            <th>Type</th>
                                            <th className="text-end">Amount</th>
                                            <th className="text-end">NAV</th>
                                            <th className="text-end">Units</th>
                                            <th>Folio No</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {transactions.map((txn) => (
                                            <tr key={txn.id}>
                                                <td>{formatDate(txn.date)}</td>
                                                <td>
                                                    <span
                                                        className={`badge ${txn.type === "Purchase" || txn.type === "SIP"
                                                            ? "bg-success"
                                                            : txn.type === "Redemption"
                                                                ? "bg-danger"
                                                                : "bg-warning"
                                                            }`}
                                                    >
                                                        {txn.type}
                                                    </span>
                                                </td>
                                                <td className="text-end">
                                                    {txn.type === "Redemption" ? "-" : ""}
                                                    {formatINR(txn.amount)}
                                                </td>
                                                <td className="text-end">{formatINR(txn.nav)}</td>
                                                <td
                                                    className={`text-end ${txn.units < 0 ? "text-danger" : "text-success"
                                                        }`}
                                                >
                                                    {txn.units > 0 ? "+" : ""}
                                                    {txn.units.toFixed(2)}
                                                </td>
                                                <td>{txn.folioNo}</td>
                                                <td>
                                                    <span className="badge bg-success">{txn.status}</span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className="table-light">
                                        <tr>
                                            <th colSpan="2" className="text-end">
                                                Total
                                            </th>
                                            <th className="text-end">
                                                {formatINR(
                                                    transactions
                                                        .filter((t) => t.type !== "Redemption")
                                                        .reduce((sum, t) => sum + t.amount, 0) -
                                                    transactions
                                                        .filter((t) => t.type === "Redemption")
                                                        .reduce((sum, t) => sum + t.amount, 0)
                                                )}
                                            </th>
                                            <th></th>
                                            <th className="text-end">
                                                {transactions
                                                    .reduce((sum, t) => sum + t.units, 0)
                                                    .toFixed(2)}
                                            </th>
                                            <th></th>
                                            <th></th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
        </>
    );
}
